import {
  QueryStringFormat,
  QueryStringParams,
  ParseContext,
} from "zustand-querystring";

/**
 * Custom format based on https://github.com/nitedani/zustand-querystring/blob/main/packages/zustand-querystring/src/format/json.ts#L3-L40,
 * with modifications to support URL encoding using {@link encodeURIComponent} & {@link decodeURIComponent}
 */
export const customJsonFormat: QueryStringFormat = {
  stringify(state: object): string {
    return encodeValue(state);
  },

  parse(value: string, _ctx?: ParseContext): object {
    return decodeValue(value) as object;
  },

  stringifyStandalone(state: object): QueryStringParams {
    const result: QueryStringParams = {};
    for (const [key, v] of Object.entries(state)) {
      result[key] = [encodeValue(v)];
    }
    return result;
  },

  parseStandalone(params: QueryStringParams, _ctx: ParseContext): object {
    const result: Record<string, unknown> = {};
    for (const [key, values] of Object.entries(params)) {
      try {
        result[key] = decodeValue(values[0]!);
      } catch {
        // skip invalid values
      }
    }
    return result;
  },
};

const encodeValue = (input: unknown): string => {
  return encodeURIComponent(JSON.stringify(input));
};

const decodeValue = (str: string): unknown => {
  return JSON.parse(decodeURIComponent(str));
};
